<template>
  <section :style="dialog.isShow ? '' : 'height: 0'">

    <!--显示详情信息-->
    <common-dialog @close="dialog.isShow=false"
                   :width="windowStatus?'90%':'80%'"
                   :close-on-click-modal="false"
                   :visible="dialog.isShow"
                   class="spec-dialog" style="top: -60px">
      <div class="dialog-title" slot="title">
        <template>
          <div>
            审核信息详情（<span
            v-show="dialog.form.postTpCode === ARTICLE_SJD_TYPE_CODE">三角地</span><span
            v-show="dialog.form.postTpCode === ARTICLE_DLB_TYPE_CODE">大喇叭</span><span
            v-show="dialog.form.postTpCode === ARTICLE_CASE_DISCUSS_TYPE_CODE">病例讨论</span><span
            v-show="dialog.form.postTpCode === ARTICLE_CASE_SHARE_TYPE_CODE">动态共享</span>）
          </div>
        </template>
      </div>
      <div :class="windowStatus?'panelLeft':''" style="height: 65vh;overflow-y: hidden;">
        <div style="height: 100px;overflow-y: auto">
          <div class="post-title"> {{ dialog.form.postTitle }}</div>
          <div class="post-userName">{{ dialog.form.userName }}</div>
          <div class="post-createTm"> {{ dialog.form.createTm | dateFormat }}</div>
        </div>
        <div class="post-content" v-html="dialog.form.postContent"></div>
        <!--<div class="post-rejectReason" v-if="dialog.form.rejectReason">被拒原因 : {{ dialog.form.rejectReason }}</div>-->
      </div>
      <div class="panelRight" v-show="windowStatus" style="height: 80%;overflow-y: hidden;text-align: center">
        <div style="text-align: center;padding-bottom:20px;font-size: 16px;font-weight: bold">附件列表</div>
        <el-scrollbar :style="dialog.opt ? 'height: calc(60% - 80px)':'height: calc(100% - 80px)'" ref="scrollbar">
          <div style="width: calc(100% - 10px)">
            <el-table :data="fileDialog.tableDataList" border size="small"
                      :header-cell-style="{ background: '#e5f5f9',fontSize:'13px',color:'#353739' }" :stripe="true">
              <el-table-column align="center" prop="attachmentOriginalName" label="" width="70px">
                <template slot-scope="scope">
                  <i :class="scope.row.attachmentOriginalName | fileIcon(this_)"></i>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="attachmentOriginalName" label="原名"></el-table-column>
              <el-table-column align="center" prop="attachmentName" label="别名">
                <template slot-scope="scope">
                  <el-input class="text-input" disabled v-model="scope.row.attachmentName"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="" label="操作" width="100">
                <template slot-scope="scope">
                  <!--查看附件-->
                  <el-button style="border:0px !important;" type="text" size="small" class="el-icon-download"
                             @click="preViewAttachment(scope.row,scope.$index)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-scrollbar>

      </div>
      <template slot="footer">
        <common-button v-if="btnFlag" size="default" type="primary" image @click="handleAgreeDialog()">同意</common-button>
        <common-button v-if="btnFlag" size="default" type="cancel" image @click="handleRefuseDialog()">拒绝</common-button>
        <common-button size="default" type="cancel" image @click="dialog.isShow = false">取消</common-button>
      </template>
    </common-dialog>

    <el-dialog
      title="审核拒绝原因"
      :visible.sync="rejectVisible"
      width="40%"
      center>
      <span>
        <el-input
          type="textarea"
          :autosize="{ minRows: 8, maxRows:12}"
          placeholder="请输入拒绝的原因"
          v-model="dialog.form.rejectReason"
          maxlength="30"
          show-word-limit>
        </el-input>
      </span>
      <span slot="footer" class="dialog-footer">
        <common-button size="default" type="cancel" image @click="rejectVisible = false">取 消</common-button>
        <common-button size="default" type="primary" image @click="approveRefuse">确 定</common-button>
    </span>
    </el-dialog>

    <el-dialog
      title="审核通过"
      :visible.sync="agreeVisible"
      width="30%"
      center>
      <span>确定审核通过 <b>{{ dialog.form.postTitle }}？</b></span>
      <span slot="footer" class="dialog-footer">
        <common-button size="default" type="cancel" image @click="agreeVisible = false">取 消</common-button>
        <common-button size="default" type="primary" image @click="approveAgree">确 定</common-button>
      </span>
    </el-dialog>

    <!--加载动画-->
    <animation :loadingDataVisible="loadingDataVisible"/>

    <el-image
      :preview-src-list="attachment.attachmentsLink"
      ref="previewImg">
    </el-image>
  </section>
</template>

<script>
import animation from '../loading/animation'
import {articleMixin} from "../../pages/mixins/articleMixin";
import {Message} from "element-ui";
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import {ATTA_FILE_SUF_LIST, ATTA_FILE_SHOW_TYPE, ATTA_FILE_DOWN_TYPE} from '@/constants/constants'
import {formatDatetime} from '@/utils/dateUtil'

export default {
  name: "PostApprove",
  mixins: [articleMixin],
  props: {
    tpCode: {
      type: String,
      default: null,
    },

    visible: {
      type: Boolean,
      default: false,
    },

    row: {
      type: Object,
      default: () => {
        return {}
      }
    },

    btnFlag: {
      type: Boolean,
      default: true,
    }

  },
  data() {
    return {
      //拒绝通过提示框
      rejectVisible: false,
      //同意通过提示框
      agreeVisible: false,
      loadingDataVisible: false,
      approve: {
        status: '0',
        keyWord: '',
        postTpCode: '-1',
        timeRange: [],
      },

      pagination: {
        pageCount: 20,
        currentPage: 1,
        pageSize: 20,
      },

      tableData: [],

      //附件弹窗信息
      this_: this,
      fileDialog: {
        attachmentName: '',
        cd: '001-015',
        showFileList: [],
        fileList: [],
        tableDataList: [],
        attaFileSuf: ATTA_FILE_SUF_LIST,
        attaFileType: ATTA_FILE_SHOW_TYPE,
        attaFileDownType: ATTA_FILE_DOWN_TYPE,
        drawerVisible: false,
        fileSaveBtnLoading: false,
        updateFlag: false,
        uploadLoading: false,
      },
      dialog: {
        dialogType: null,
        editedFlag: false,
        isShow: false,
        isLoading: false,
        //附件上传框 是否可见
        opt: false,
        form: {
          tpCode: '',
          postCode: '',
          title: '',
          createUserName: '',
          createTm: '',
          content: '',
          //附加列表
          attachIds: [],
          rejectReason: "",
        }
      },
      fileIconType: {
        'ppt': 'icon-file-ppt-fill',
        'xls': 'icon-file-excel-fill',
        'xlsx': 'icon-file-excel-fill',
        'doc': 'icon-file-word-fill',
        'docx': 'icon-file-word-fill',
        'pdf': 'icon-file-pdf-fill',
        'jpg': 'icon-tupian',
        'png': 'icon-tupian',
        'gif': 'icon-tupian',
        'jpeg': 'icon-tupian',
        'txt': 'icon-wenjian',
        "unKnown": "icon-bg-unknownfile",
      },
      attachment: {
        attachmentsLink: [],
        //图片的类型后缀
        imagesType: ['jpg', 'jpeg', 'png', 'gif'],
      },
    }
  },

  components: {
    animation,
  },

  watch: {

    visible(newVal) {
      this.dialog.isShow = newVal
    },

    'dialog.isShow'(newVal) {
      this.$emit('update:visible', newVal)
      if (newVal) {
        this.dialog.form = this.$options.data().dialog.form
        this.showApproveInfo(this.row)
      }
    },
  },

  computed: {
    windowStatus(item) {
      return this.dialog.form.attachments ? this.dialog.form.attachments.length !== 0 : false
    }
  },

  methods: {

    //根据不同的模块导航到不同的页面
    showApproveInfo(row) {
      this.loadingDataVisible = true
      let _this = this;
      this.dialog.isLoading = true;
      http.post(window.config.api.baseUrl + '/eims-api/share/approve/findById', {
        token: cookie.getCookie("token"),
        data: {
          postCode: row.postCode,
          tpCode: row.postTpCode,
        }
      }).then((response) => {

        if (response.data.code == "00000"){
          let data = response.data.data;
          this.dialog.form = data.article
          this.dialog.form.createTm = formatDatetime(data.article.createTm, 'yyyy-MM-dd \n hh:mm:ss');
          this.fileDialog.tableDataList = data.article.attachments;
          this.dialog.isShow = true
          this.openFileList()
        }
      }).finally(() => {
        _this.loadingDataVisible = false
        _this.dialog.isLoading = false;
      });
    },

    //预览附件
    preViewAttachment(item, index) {
      //准备需要查看的附件的链接,然后显示或者下载附件
      let fullName = item.attachmentOriginalName
      //如果不是图片的格式的附件,则使用上面这种预览方式
      if (!this.attachment.imagesType.includes(fullName.substring(fullName.lastIndexOf(".") + 1))) {
        //浏览器自带的预览,附件列表的数据长度可能和表格中显示的长度不一致,需要重新修改显示的附件的索引
        let file = this.fileDialog.fileList[index - (this.fileDialog.tableDataList.length - this.fileDialog.fileList.length)]
        if (file) {
          //附件未上传预览
          this.handleView(file)
        } else {
          //附件已上传的预览
          this.handleView(this.fileDialog.tableDataList[index])
        }

        //如果是图片则使用这种预览方式
      } else {
        //生成附件的预览链接
        this.generateAttachmentsPath(this.fileDialog.tableDataList, index)
        if (this.attachment.attachmentsLink.length !== 0) {
          //el-image组件的预览
          this.$refs.previewImg.showViewer = true;
        } else {
          //浏览器自带的预览,附件列表的数据长度可能和表格中显示的长度不一致,需要重新修改显示的附件的索引
          this.handleView(this.fileDialog.fileList[index - (this.fileDialog.tableDataList.length - this.fileDialog.fileList.length)])
        }
      }
    },

    //打开附件,准备附件的数据
    openFileList() {
      if (this.dialog.form.attachIds && this.dialog.form.attachIds.length > 0) {
        this.fileDialog.tableDataList = JSON.parse(JSON.stringify(this.dialog.form.attachIds))
      }
      this.fileDialog.drawerVisible = true;
      this.fileDialog.updateFlag = false;
    },

    //将传来的附件生成附件的链接
    generateAttachmentsPath(attachments, index) {
      let attachmentsLink = []
      //将index这个文件放在第一个,给image组件使用的
      for (let i = index; i < attachments.length; i++) {
        let attachment = attachments[i]
        let attachName = attachment.attachmentOriginalName
        if (this.attachment.imagesType.includes(attachName.substring(attachName.lastIndexOf(".") + 1))) {
          if (attachment.code !== undefined) {
            attachmentsLink.push(window.config.api.baseUrl + '/eims-api/attachment/findFile?token=' + cookie.getCookie("token") + '&code=' + attachment.code);
          }
        }
      }
      if (attachmentsLink.length === 0) {
        this.attachment.attachmentsLink = []
        return
      }
      for (let i = 0; i < index; i++) {
        let attachment = attachments[i]
        let attachName = attachment.attachmentOriginalName
        if (this.attachment.imagesType.includes(attachName.substring(attachName.lastIndexOf(".") + 1))) {
          if (attachment.code !== undefined) {
            attachmentsLink.push(window.config.api.baseUrl + '/eims-api/attachment/findFile?token=' + cookie.getCookie("token") + '&code=' + attachment.code);
          }
        }
      }
      this.attachment.attachmentsLink = attachmentsLink
    },


    //准备需要查看的附件的链接,然后显示或者下载附件
    handleView(item) {
      if (item.file) {
        let fileType = item.file.name.substring(item.file.name.lastIndexOf('.') + 1)
        let attaFileTypeElement = this.fileDialog.attaFileType[fileType];
        const elink = document.createElement('a');
        if (!attaFileTypeElement) {
          elink.download = item.file.name;
        }
        elink.style.display = 'none';
        elink.target = '_blank';
        // elink.href = URL.createObjectURL(new Blob([item.file.raw],{type:attaFileTypeElement}));
        elink.href = URL.createObjectURL(item.file);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      } else {
        let fileType = item.attachmentOriginalName.substring(item.attachmentOriginalName.lastIndexOf('.') + 1)
        let attaFileTypeElement = this.fileDialog.attaFileType[fileType];
        const elink = document.createElement('a');
        if (!attaFileTypeElement) {
          http.get(window.config.api.baseUrl + '/eims-api/attachment/findFile?token=' + cookie.getCookie("token") + '&code=' + item.code,
            {responseType: "blob"}).then(response => {
            if (response) {
              let attaFileDownTypeElement = this.fileDialog.attaFileDownType[fileType];
              if (item.attachmentName) {
                //使用附件的别名
                elink.download = item.attachmentName + "." + fileType
              } else {
                //使用附件的原名
                elink.download = item.attachmentOriginalName;
              }
              elink.style.display = 'none';
              elink.target = '_blank';
              elink.href = URL.createObjectURL(new Blob([response.data], {type: attaFileDownTypeElement}));
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href);
              document.body.removeChild(elink);
            }
          }).catch(error => {
            console.log(error)
          })
        } else {
          elink.style.display = 'none';
          elink.target = '_blank'
          elink.href = window.config.api.baseUrl + '/eims-api/attachment/findFile?token=' + cookie.getCookie("token") + '&code=' + item.code;
          // elink.href = URL.createObjectURL(new Blob([response],{type:attaFileTypeElement}));
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        }
      }
    },

    handleAgreeDialog() {
      this.agreeVisible = true
    },

    //同意审核
    approveAgree() {
      this.loadingDataVisible = true
      http.post(window.config.api.baseUrl + '/eims-api/share/approve/approve', {
        token: cookie.getCookie("token"),
        data: {
          tpCode: this.dialog.form.tpCode,
          postCode: this.dialog.form.postCode,
          status: this.APPROVE_STATUS_AGREE
        }
      }).then((response) => {
        if (response.data.code === '00000') {
          Message.success("审核成功")
        }
        this.$emit("refresh")
      }).finally(() => {
        this.agreeVisible = false
        this.loadingDataVisible = false
        this.dialog.isShow = false
      })
    },

    //拒绝审核
    handleRefuseDialog() {
      this.rejectVisible = true
    },

    //拒绝通过
    approveRefuse() {
      if(!this.validateDialogForm()){
        return
      }
      this.loadingDataVisible = true
      http.post(window.config.api.baseUrl + '/eims-api/share/approve/approve', {
        token: cookie.getCookie("token"),
        data: {
          tpCode: this.dialog.form.tpCode,
          postCode: this.dialog.form.postCode,
          status: this.APPROVE_STATUS_REFUSE,
          rejectReason: this.dialog.form.rejectReason
        }
      }).then((response) => {
        if (response.data.code === "00000"){
          Message.success("已拒绝通过")
        }
        this.$emit("refresh")
      }).finally(() => {
        this.rejectVisible = false
        this.dialog.isShow = false
        this.loadingDataVisible = false
      })
    },
    //校验参数
    validateDialogForm() {
      let flag = true
      if ((!this.dialog.form.rejectReason || !this.dialog.form.rejectReason.trim()) && flag) {
        Message.error({message: "拒绝原因不能为空"})
        flag = false
      }
      return flag
    },

  },

}
</script>

<style scoped>
.approve-center {
  /*padding: 20px;*/
}

.approve-center-list {
  margin: 20px 0;
}

.form-heard button {
  margin: 0 10px;
}

.btn-select {
  color: white;
  border-width: 1px;
  border-color: transparent;
  background: rgb(41, 196, 228);
}

.btn-select:hover {
  background: rgb(35, 170, 196);
}

.btn-select:active {
  background: rgb(22, 121, 141);
}

.btn-reset {
  color: rgb(41, 196, 228);
  background-color: white;
  border: rgb(41, 196, 228) 1px solid;
}

.btn-reset:hover {
  background-color: rgb(238, 245, 252);
}

.btn-reset:active {
  background-color: rgb(230, 246, 253);
}

.icon-shenhe {
  color: #0d8efa;
}

.eims-button--text {
  border-color: transparent;
  color: #409eff;
  background: transparent;
}

.case-share-detail {
  position: relative;
  margin: 0 auto 50px;
  background: #FFF;
  border-radius: 2px;
  -webkit-box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
  box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

/*操作的左面板*/
.panelLeft {
  height: 65vh;
  overflow-y: auto;
  width: 70%;
  float: left;
  padding-right: 10px;
}

/*操作的右面板*/
.panelRight {
  padding-left: 50px;
  padding-right: 10px;
  width: 30%;
  position: relative;
  float: right;
  height: 65vh !important;
  overflow-y: auto;

}

/deep/ .el-dialog__footer {
  clear: both;
}

/deep/ .form-body .el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #F3FDFF !important;
}

/*脚部的居中显示*/
/deep/ .el-dialog__footer {
  text-align: center;
}

/deep/ .el-image__error {
  display: none;
}

i.icon-fenxiang {
  color: #29c4e4;
  font-size: 18px;
}

i.icon-file-ppt-fill {
  color: #ff7082;
  font-size: 40px;
}

i.icon-file-word-fill {
  color: #008dfa;
  font-size: 40px;
}

i.icon-PDF {
  color: #eb5e5e;
  font-size: 40px;
}

i.icon-file-excel-fill {
  color: #00c090;
  font-size: 40px;
}

/*时间范围中间文字的层级,不设置可能会出现文字被遮挡的问题*/
/deep/ .el-date-editor .el-range-separator {
  z-index: 2
}

.el-icon-warning-outline {
  margin: 0 5px;
}

.post-title {
  font-size: 20px;
  text-align: center;
  width: 100%;
  display: inline-block;
}

.post-userName {
  text-align: right;
  font-size: 14px;
  color: #a6a6a6;
}

.post-createTm {
  text-align: right;
  font-size: 14px;
  color: #888888;
}

.post-content {
  overflow: auto;
  height: calc(65vh - 120px);

}

.post-rejectReason {
  color: red;
  height: 30px;
  font-size: 16px;
  line-height: 20px;
  overflow: auto;

}

</style>



// WEBPACK FOOTER //
// src/components/detail/PostApprove.vue